import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button, { CancelButton, ConfirmButton } from 'components/ui/Button';
import { StyledButtonWrapper, StyledWrapper } from './UpdateDiscountCTA.styles';
import { useDiscountEditSettings } from '../hooks/useDiscountEditSettings';

const UpdateDiscountCTA = ({ onCancelClick, onEditClick, isEditMode, isConfirmEnabled, disabled }) => {
  const editSettings = useDiscountEditSettings();
  if (!editSettings.form.isDiscountEditable) return <></>;

  return (
    <>
      {!isEditMode && (
        <StyledButtonWrapper>
          <Button type="button" data-cy="edit" onClick={onEditClick} disabled={disabled}>
            <FormattedMessage id="vouchers.edit" />
          </Button>
        </StyledButtonWrapper>
      )}
      {isEditMode && (
        <StyledWrapper>
          <StyledButtonWrapper>
            <CancelButton type="button" data-cy="cancel" onClick={onCancelClick}>
              <FormattedMessage id="vouchers.cancel" />
            </CancelButton>
          </StyledButtonWrapper>
          <StyledButtonWrapper>
            <ConfirmButton type="submit" data-cy="submit" disabled={!isConfirmEnabled}>
              <FormattedMessage id="vouchers.confirm" />
            </ConfirmButton>
          </StyledButtonWrapper>
        </StyledWrapper>
      )}
    </>
  );
};

UpdateDiscountCTA.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  isConfirmEnabled: PropTypes.bool,
  hasVoucherExpired: PropTypes.bool,
  disabled: PropTypes.bool
};

export default UpdateDiscountCTA;
